import request from '@/utils/request'

// 查询类型列表
export function listTableCategory(data) {
  return request({
    url: '/sysAuthType/list',
    method: 'post',
    data,
  })
}

// 查询类型列表
export function listTableCategory1(data) {
  return request({
    url: '/sysAuthType/list',
    method: 'post',
    data,
  })
}

// 新增类型
export function addTable(data) {
  return request({
    url: '/sysAuthType/insert',
    method: 'post',
    data: data,
  })
}
// 修改类型
export function updateTable(data) {
  return request({
    url: '/sysAuthType/update',
    method: 'post',
    data: data,
  })
}

// 删除类型
export function delTable(data) {
  return request({
    url: `/sysAuthType/delete/?id=${data}`,
    method: 'get',
  })
}
